import { render, staticRenderFns } from "./CartBtn.vue?vue&type=template&id=42e4a54e"
import script from "./CartBtn.vue?vue&type=script&lang=ts"
export * from "./CartBtn.vue?vue&type=script&lang=ts"
import style0 from "./CartBtn.vue?vue&type=style&index=0&id=42e4a54e&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports